
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pemetaan-kompetensi/panduan",
      function () {
        return require("private-next-pages/pemetaan-kompetensi/panduan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pemetaan-kompetensi/panduan"])
      });
    }
  